
import Vue from "vue";
import { Ledgers } from "../Ledger";
import { type SyncManager, SyncManagers } from "../Sync";
import {s} from "../L10n";

export default Vue.extend({
  data: () => {
    return {
      clients: SyncManagers.all() as SyncManager[],
      changeCallback: null as null | (() => void),
    };
  },
  mounted() {
    this.changeCallback = () => this.refresh();
    for (let sync of this.clients) {
      sync.addEventListener(
        "change",
        this.changeCallback
      );
    }
  },
  beforeDestroy() {
    for (let sync of this.clients) {
      sync.removeEventListener(
        "change",
        this.changeCallback
      );
    }
  },
  methods: {
    refresh() {
      this.clients = SyncManagers.all();
    },
    onClick(clientId: string) {
      this.$router.push({ name: 'ledger', params: {id: clientId}});
    },
    async newLedger() {
      const ledger = Ledgers.add(undefined, undefined, s("Untitled List"), " ");
      await SyncManagers.register(ledger);
      this.$router.push({name: "metadata", params: {id: ledger.id}});
    },
    async joinLedger() {
      this.$router.push({name: 'join'});
    },
    s(str: string): string {
      return s(str);
    }
  },
  computed: {
    /**
     * Like clients, but sorted alphabetically.
     */
    clientsSorted(): SyncManager[] {
      const ret = this.clients.slice();
      ret.sort((a, b) => a.name.localeCompare(b.name));
      return ret;
    },
    gitHash(): string {
      const h = process.env.VUE_APP_GIT_HASH;
      if (h) {
        return ` · ${s('Version')} ${h}`;
      }
      return "";
    }
  },
});
